import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import { baseGrid } from '@helpers/grid';
import { Device, from, until } from '@helpers/media';
import { contentStyles, h4, table } from '@helpers/typography';
import CtaLinkStyles from '@stories/Components/Buttons/CtaLink/CtaLink.styles';
import FieldSharedStyles from '@stories/Components/FormFields/FieldShared.styles';
import DropdownStyles from '@stories/Components/Inputs/Dropdown/Dropdown.styles';
import SectionWrapper from '@stories/Components/Misc/SectionWrapper/SectionWrapper';
import SectionWrapperStyles from '@stories/Components/Misc/SectionWrapper/SectionWrapper.styles';
import { rgba } from 'polished';
import styled from 'styled-components';
const Container = styled(SectionWrapper) `
  ${SectionWrapperStyles.Inner} {
    ${baseGrid};

    row-gap: ${fluid(40, 48)};
  }
`;
const ContentWrapper = styled.div `
  grid-column: 1 / span 24;

  @media ${from(Device.TabletLarge)} {
    grid-column: 1 / span 16;
  }

  @media ${from(Device.Desktop)} {
    grid-column: 1 / span 15;
  }

  @media ${from(Device.DesktopLarge)} {
    grid-column: 2 / span 14;
  }
`;
const Title = styled.h2 `
  ${h4};

  margin-bottom: ${fluid(30, 32)};
`;
const Content = styled.div `
  ${contentStyles};

  p {
    font-size: ${fluid(16, 20)};
    line-height: ${fluid(26, 32)};
  }

  &[data-disclaimer] {
    margin-top: -20px;

    p {
      font-size: ${fluid(14, 16)};
      line-height: ${fluid(24, 26)};

      &:not(:last-child) {
        margin-bottom: ${fluid(8, 12)};
      }
    }
  }
`;
const DropdownWrapper = styled.div `
  grid-column: 1 / span 24;

  ${FieldSharedStyles.Container} {
    width: 100%;
    margin-bottom: 0;
  }

  ${DropdownStyles.Container}[data-value='false'] ${DropdownStyles.Select} {
    color: ${rgba(brand.base.blue, 0.5)};

    option {
      color: ${brand.base.blue};
    }
  }

  ${DropdownStyles.Select} {
    border-color: ${brand.secondary.blueGrey};
  }

  @media ${from(Device.TabletLarge)} {
    display: flex;
    align-items: flex-end;
    height: 100%;
    grid-column: 17 / span 8;
  }

  @media ${from(Device.Desktop)} {
    grid-column: 18 / span 7;
  }

  @media ${from(Device.DesktopLarge)} {
    grid-column: 18 / span 6;
  }
`;
const TableWrapper = styled.div `
  grid-column: 1 / span 24;

  @media ${from(Device.DesktopLarge)} {
    grid-column: 2 / span 22;
  }
`;
const Table = styled.table `
  ${table}

  thead, 
  tbody {
    tr {
      th {
        @media ${until(Device.TabletLarge)} {
          display: none;
        }
      }

      th,
      td {
        vertical-align: middle;

        @media ${from(Device.TabletLarge)} {
          text-align: center;
        }
      }
    }
  }

  thead tr th:last-child {
    background-color: ${brand.primary.orange};
  }

  tbody tr {
    @media ${until(Device.TabletLarge)} {
      display: table;
      background: none;
      width: 100%;

      &:not(:last-of-type) {
        margin-bottom: 20px;
      }
    }

    td {
      &[data-label='false'] {
        display: none;
      }

      span[data-bold] {
        font-weight: 700;
      }

      span[data-discount-label] {
        display: block;

        font-size: ${fluid(12, 14)};
        line-height: ${fluid(16, 18)};
      }

      @media ${until(Device.TabletLarge)} {
        display: table-row;

        &::before {
          content: attr(data-label);
          font-weight: 700;
          color: ${brand.white};
          background: ${brand.primary.blue};
          padding: 16px 24px 16px 16px;
        }

        &:last-child::before {
          background: ${brand.primary.orange};
        }

        > span {
          background: ${brand.primary.blueGrey};
          padding: 16px 16px 16px 24px;
        }

        > span,
        &::before {
          display: table-cell;
        }

        &[data-hide-mobile='true'] {
          display: none;
        }
      }
    }
  }

  ${CtaLinkStyles.Container} {
    font-size: ${fluid(16, 20)};
    line-height: ${fluid(26, 32)};
    white-space: nowrap;

    svg {
      width: 13px;
    }

    @media ${until(Device.MobileLarge)} {
      span {
        white-space: normal;
      }
    }
  }
`;
const SubscriptionRateTableStyles = {
    Container,
    ContentWrapper,
    DropdownWrapper,
    Title,
    Content,
    TableWrapper,
    Table,
};
export default SubscriptionRateTableStyles;
